/*@ngInject*/
const UIEnterDirective = function () {

    let linkFunction = function ($scope, $elm, $attrs) {

        function handleKeypress(event) {
            if (event.which === 13) {
                $scope.$apply(function () {
                    $scope.$eval($attrs.uiEnter, {'event': event});
                });

                event.preventDefault();
            }
        }

        $elm.bind('keydown keypress', handleKeypress);

        $scope.$on('$destroy', function () {
            $elm.unbind('keydown keypress', handleKeypress);
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiEnter', UIEnterDirective);
